import styled from 'styled-components';
import { BigButton } from '../Button/styles';
import { StyleColor } from '../../utils/styles-constants';

export const StyledStaleOfflineCleanupContent = styled('div')`
	padding: 100px 65px 90px 65px;
	background-color: ${StyleColor.White};
	display: flex;
	flex-direction: column;
	z-index: 12;
	align-items: center;
	position: relative;
	pointer-events: auto;
`;

export const StaleOfflineCleanupClose = styled('div')`
	position: absolute;
	top: 30px;
	right: 30px;
	cursor: pointer;

	> svg {
		width: 19px;
		height: 19px;
	}
`;

export const StaleOfflineCleanupLabel = styled('div')`
	font-weight: 600;
	font-size: 18px;
	color: ${StyleColor.Grey800};
	margin-bottom: 35px;
	text-align: center;
`;

export const CleanUpStaleOfflineButton = styled(BigButton)`
	margin-bottom: 30px;
`;

export const KeepStaleOfflineButton = styled(BigButton)`
	background-color: ${StyleColor.Green};
	margin-bottom: 30px;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/StaleOfflineCleanupContent/styles.ts